import React from "react";

import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import CampaignIcon from "@mui/icons-material/Campaign";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import SquareFootIcon from "@mui/icons-material/SquareFoot";
import FeaturedPlayListIcon from "@mui/icons-material/FeaturedPlayList";
import AdjustIcon from "@mui/icons-material/Adjust";
import StepConnector, {
     stepConnectorClasses,
} from "@mui/material/StepConnector";
import { styled } from "@mui/material/styles";
import {
     UiButton,
     UiBackButton,
} from "../../_uiComponents/common/form/UiButton";
import { MainLeftTitle } from "../../_uiComponents/WrapperComponents";

import Campaign from "./views/steps/campaign/Campaign";
import Rewards from "./views/steps/rewards/Rewards";
import Measurements from "./views/steps/measurements/Measurements";
import Content from "./views/steps/content/Content";
import Targets from "./views/steps/targets/Targets";
import DataSection from "./views/steps/data/DataSection";

const steps = ["Campaign", "Content", "Rewards","Data"];
// const steps = ["Campaign", "Targets", "Content", "Rewards"];

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
     [`&.${stepConnectorClasses.alternativeLabel}`]: {
          top: 20,
     },
     [`&.${stepConnectorClasses.active}`]: {
          [`& .${stepConnectorClasses.line}`]: {
               backgroundImage:
                    "linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)",
          },
     },
     [`&.${stepConnectorClasses.completed}`]: {
          [`& .${stepConnectorClasses.line}`]: {
               backgroundImage:
                    "linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)",
          },
     },
     [`& .${stepConnectorClasses.line}`]: {
          height: 3,
          border: 0,
          backgroundColor:
               theme.palette.mode === "dark"
                    ? theme.palette.grey[800]
                    : "#eaeaf0",
          borderRadius: 1,
     },
}));

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
     backgroundColor:
          theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
     zIndex: 1,
     color: "#fff",
     width: 50,
     height: 50,
     display: "flex",
     borderRadius: "50%",
     justifyContent: "center",
     alignItems: "center",
     ...(ownerState.active && {
          backgroundImage:
               "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
          boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
     }),
     ...(ownerState.completed && {
          backgroundImage:
               "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
     }),
}));

function ColorlibStepIcon(props) {
     const { active, completed, className } = props;

     const icons = {
          1: <CampaignIcon />,
          2: <AdjustIcon />,
          3: <FeaturedPlayListIcon />,
          4: <EmojiEventsIcon />,
     };

     return (
          <ColorlibStepIconRoot
               ownerState={{ completed, active }}
               className={className}
          >
               {icons[String(props.icon)]}
          </ColorlibStepIconRoot>
     );
}

export default function CreateIncentive() {
     const [activeStep, setActiveStep] = React.useState(0);
     const [completed, setCompleted] = React.useState({});

     const totalSteps = () => {
          return steps.length;
     };

     const completedSteps = () => {
          return Object.keys(completed).length;
     };

     const isLastStep = () => {
          return activeStep === totalSteps() - 1;
     };

     const allStepsCompleted = () => {
          return completedSteps() === totalSteps();
     };

     const handleNext = () => {
          const newActiveStep =
               isLastStep() && !allStepsCompleted()
                    ? steps.findIndex((step, i) => !(i in completed))
                    : activeStep + 1;
          setActiveStep(newActiveStep);
     };

     const handleBack = () => {
          setActiveStep((prevActiveStep) => prevActiveStep - 1);
     };
     const handleStep = (step) => {
          setActiveStep(step);
     };

     return (
          <>
               <Box sx={{ width: "100%" }} spacing={2}>
                    <div className="sbt-data-grid__wr">
                         <MainLeftTitle title="Create Incentive Campaign"></MainLeftTitle>
                    </div>
                    <Stepper
                         Linear
                         activeStep={activeStep}
                         connector={<ColorlibConnector />}
                         className="sbt-stepper-area"
                    >
                         {steps.map((label, index) => (
                              <Step key={label} completed={completed[index]}>
                                   <StepLabel
                                        color="inherit"
                                        StepIconComponent={ColorlibStepIcon}
                                        onClick={() => handleStep(index)}
                                   >
                                        {label}
                                   </StepLabel>
                              </Step>
                         ))}
                    </Stepper>

                    <>
                         <div className="sba-campaign-content">
                              {activeStep == 0 && (
                                   <Campaign
                                        handleStep={handleStep}
                                        step={activeStep}
                                   />
                              )}
                              {activeStep == 2 &&
                                   <Rewards />
                              }
                               {activeStep == 1 && <Content />}
                                {activeStep == 3 && <DataSection />} 
                              {/* {activeStep == 2 && <Measurements />} */}
                              {/* {activeStep == 1 &&
                                   <Targets />
                              } */}

                             
                         </div>
                    </>

                    <div className="sba-button-campaign-main-wr">
                         {activeStep !== 0 && (
                              <UiBackButton
                                   color="inherit"
                                   disabled={activeStep === 0}
                                   onClick={handleBack}
                                   sx={{ mr: 1 }}
                              >
                                   Back
                              </UiBackButton>
                         )}
                         {activeStep === steps.length - 1 ? (
                              <UiButton
                                   name="Finish"
                                   variant="outlined"
                                   size="small"
                                   sx={{ mr: 1 }}
                              />
                         ) : (
                              <div className="sba-create-campaign-next-btn">
                                   <UiButton
                                        name="Next"
                                        variant="outlined"
                                        size="small"
                                        onClick={handleNext}
                                        sx={{ mr: 1 }}
                                   />
                              </div>
                         )}
                    </div>
               </Box>
          </>
     );
}
